<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn" @click="initHomeworkManageTeaData()"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">作业管理&gt;</div>
      </div>
      <div class="body_content">
        <div class="situation_all_div">
          <div class="situation_one_div" @click="initHomeworkManageTeaData(0)">
            全部
            <div class="situation_one_img"><img src="../assets/img/right/clazz/sousuo.png"/></div>
          </div>
          <div class="situation_one_div" @click="initHomeworkManageTeaData(1)">
            未完成
            <div class="situation_one_img"><img src="../assets/img/right/clazz/sousuo.png"/></div>
          </div>
          <!-- <div class="situation_one_div">
             已评分
             <div class="situation_one_img"><img src="../assets/img/right/clazz/sousuo.png"/></div>
           </div>
           <div class="situation_one_div">
             未评分
             <div class="situation_one_img"><img src="../assets/img/right/clazz/sousuo.png"/></div>
           </div>-->
        </div>
        <div class="classList_div">
          <table class="table table-striped tabShow homework_tab">
            <thead>
            <tr>
              <th width="25%">班级名称</th>
              <th width="30%">作业内容</th>
              <th width="15%">批改进度</th>
              <!--<th>开始日期</th>
              <th>完成日期</th>-->
              <th width="15%">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(record, index) in markingRecordList" :key="index">
              <td width="25%">{{record.clazzName}}</td>
              <td width="30%" class="tabTd_content_ellipsis" :title="record.schoolworkName">{{record.schoolworkName}}</td>
              <td width="15%" :class="{font_read: record.endSchoolworkNum!=record.schoolworkNum}">
                {{record.endSchoolworkNum}} / {{record.schoolworkNum}}
              </td>
              <!-- <td>{{record.startTime}}</td>
               <td>{{record.endTime}}</td>-->
              <td width="15%" class="optionBtn">
                <!-- <button class="edit_pic" :disabled="record.clazzStatus == -1 || record.clazzStatus == 0" :class="{show_edit_pic: record.clazzStatus == 1}" @click="saveDataIntoStorage(record.clazzId, record.schoolworkId,record.clazzStatus)"></button>
                 <button class="details_pic" @click="saveDataIntoStorage(record.clazzId, record.schoolworkId,record.clazzStatus)"></button>-->
                <div class="edit_pic" :class="{show_edit_pic: record.clazzStatus == 1}" @click="optionFlag='edit';saveDataIntoStorage(record.clazzId, record.schoolworkId,record.clazzStatus)"></div>
                <!--<div v-else class="edit_pic"></div>-->
                <!--<div class="details_pic" @click="optionFlag='details';saveDataIntoStorage(record.clazzId, record.schoolworkId,record.clazzStatus)"></div>-->
              </td>
            </tr>


            </tbody>
          </table>
          <!--分页-->
          <div id="page-break">
            <ul>
              <li v-if="cur>1">
                <a v-on:click="cur--,pageClick()">上一页</a>
              </li>
              <li v-if="cur==1">
                <a class="banclick">上一页</a>
              </li>
              <li v-for="item in indexs" v-bind:class="{'active':cur==item}">
                <a v-on:click="btnClick(item), pageClick()">{{item}}</a>
              </li>
              <li v-if="cur!=all">
                <a v-on:click="cur++,pageClick()">下一页</a>
              </li>
              <li v-if="cur==all">
                <a class="banclick">下一页</a>
              </li>
              <li><a>共<i>{{all}}</i>页</a></li>
              <div class="jumpbox">
                <input type="number" class="jumppage" />
                <a class="jumpbtn" v-on:click="pageSkip()">跳转</a>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";

  import {getContentSize} from './mainView';
  import dictionaryData from '../json/dictionary';

  export default {
    name: "homeworkManageTea",
    data() {
      return {
        //批改记录
        markingRecordList: [],

        //未批改记录
        homeworkArr:[],

        classStatus: this.$store.state.classStatus,

        //班级状态标识
        clazz_status: dictionaryData.clazz_status,

        //操作标识
        optionFlag: '',

        //当前页
        cur: '1',
        //总页数
        all: '',
      }
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        this_.initHomeworkManageTeaData(0);

        // this_.getUnFinishedHomeworkList();
      });
    },
    watch: {
      cur: function(newValue, oldValue){
        //console.log(arguments);
      }
    },
    methods: {
      /**
       * 初始加载数据
       */
      initHomeworkManageTeaData(flag){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'schoolwork/getSchoolWorkMsg',
          params: {
            page:this_.cur,
            rows:'15',
            index:flag,
          }
        }).then(function (resp) {
          //批改记录
          let homeworkData = resp.data;
          if(homeworkData.success){
            this_.markingRecordList = homeworkData.list;
            this_.cur = homeworkData.page;
            this_.all = homeworkData.totalPage;
            //console.log(this_.all);
          }
        })
      },
      /**
       * 分页
       */
      btnClick(num){
        if(num!=this.cur){
          this.cur=num;
        }
      },
      pageClick(){
        let this_=this;
        // console.log('现在是'+this.cur+'页')
        this_.initHomeworkManageTeaData();
      },
      pageSkip(){
        var maxPage = this.all;
        var skipPage = Number(document.getElementsByClassName("jumppage")[0].value);
        //console.log(typeof skipPage);
        if(!skipPage){
          alert("请输入跳转页码");
          return;
        }else if(skipPage<1 || skipPage>maxPage){
          alert("您输入的页码超过页数范围了！");
          return;
        }else{
          //this.cur=skipPage;
          this.btnClick(skipPage);
          this.pageClick();
        }
      },
      /**
       * 点击修改或编辑时查看详情数据
       */
      saveDataIntoStorage(tea_clazzId, tea_schoolworkId,tea_clazzStatus){
        //console.info(tea_clazzId, tea_schoolworkId,tea_clazzStatus)
        let this_ = this;
        if( (this_.optionFlag == 'edit') || (this_.optionFlag == 'details') ) {
          //保存或修改

          this_.$store.set("tea_clazzId", tea_clazzId);
          this_.$store.set("tea_schoolworkId", tea_schoolworkId);
          this_.$store.set("tea_clazzStatus", tea_clazzStatus);
          //路由跳转
          this_.$router.push({
            name: 'HomeworkManageDetailsTea'
          });
        }
      },
    },
    computed: {
      indexs(){
        var left = 1;
        var right = this.all;
        var arr = [];
        if(this.all>=7){
          if(this.cur>4 && this.cur<this.all-3){
            left = this.cur-3;
            right = this.cur+3;
          }else if(this.cur<=4){
            left=1;
            right=7;
          }else{
            left=this.all-6;
            right=this.all;
          }
        }
        while(left<=right){
          arr.push(left);
          left++;
        }
        return arr;
      }
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  .situation_all_div {
    position: relative;
    top: 2%;
    width: 100%;
    height: 10%;
  }
  .situation_one_div {
    float: left;
    width: 18%;
    height: 100%;
    color: white;
    font-size: 20px;
    line-height: 75px;
    margin: 0px 1% 1% 1%;
    padding-left: 20px;
  }
  .situation_one_div:nth-child(1) {
    background-color: #FC5F5A;
  }
  .situation_one_div:nth-child(2) {
    background-color: #FC5F5A;
  }
  .situation_one_div:nth-child(3) {
    background-color: #FC5F5A;
  }
  .situation_one_div span {
    font-size: 45px;
    font-weight: bold;
  }
  .situation_one_div div {
    float: right;
    width: 25%;
    height: 100%;
  }
  .situation_one_img {
    background-color: #D6514D;
    text-align: center;
  }

  .classList_div {
    position: relative;
    top: 2%;
    width: 100%;
    height: 86%;
    overflow: auto;
  }

  .tabTd_content_ellipsis {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    -moz-text-overflow: ellipsis;
  }

  .tabShow {
    margin: 0 0 0 0;
    width: 100%;
    max-height: 100%;
    table-layout: fixed;
  }
  .tabShow tr {
    /*border-bottom: 1px grey solid;*/
    height: 50px;
  }
  .tabShow tr td{
    border: 0px;
    line-height: 32px;
  }


  .modal-body-look {
    text-align: center;
  }
  .modal-dialog-look {
    width: 60%;
  }
  .homework_tab tr th {
    background-color: #cccccc;
    color: black;
    font-size: 16px;
    text-align: center;
    line-height: 30px;
  }
  .homework_tab tr td {
    text-align: center;
    font-size: 16px;
  }
  .homework_tab tbody {
    font-weight: bold;
  }
  /*.uploadBtn {
    margin: auto;
    width: 22px;
    height: 22px;
    background-image: url("../img/right/student/uploadBtn.png");
    background-size: 100% 100%;
  }
  .uploadBtn:hover {
    background-image: url("../img/right/student/uploadBtn_over.png");
  }*/

  .font_read {
    color: #C9744F;
  }
  .edit_pic {
    width: 29px;
    height: 22px;
    /*background-image: url("../img/right/clazz/edit.png");*/
    background-image: url("../assets/img/right/clazz/edit_mouseOver.png");
    background-size: 100% 100%;
    float: left;
    margin-left: 80px;
  }
  .details_pic {
    width: 29px;
    height: 22px;
    /*background-image: url("../img/right/clazz/details.png");*/
    background-image: url("../assets/img/right/clazz/details_mouseOver.png");
    background-size: 100% 100%;
    float: left;
    margin-left: 15px;
  }
  /*.edit_pic:hover {
    background-image: url("../img/right/clazz/edit_mouseOver.png");
    cursor: pointer;
  }
  .details_pic:hover {
    background-image: url("../img/right/clazz/details_mouseOver.png");
    cursor: pointer;
  }*/
  .show_edit_pic {
    background-image: url("../assets/img/right/clazz/edit_mouseOver.png");
    cursor: pointer;
  }

  /*分页*/
  #page-break {
    margin-top: 20px;
    margin-left: 30%;
    /*  position: absolute;
      top: 50%;
      left: 50%;*/
    /*transform: translate(10%,-50%);*/
  }
  #page-break li {
    list-style: none;
  }
  #page-break a {
    border: 1px solid #ddd;
    text-decoration: none;
    float: left;
    padding: 6px 12px;
    color: #d44950;
    cursor: pointer}
  #page-break a:hover {
    background-color: #eee;
  }
  #page-break a .banclick {
    cursor: not-allowed;
  }
  #page-break .active a {
    color: #fff;
    cursor: default;
    background-color: #d44950;
    border-color: #ff6f66;
  }
  #page-break i {
    font-style: normal;
    color: #d44950;
    margin: 0px 4px;
    font-size: 12px;
  }
  #page-break .jumpbox .jumppage {
    border: 1px solid #ddd;
    margin-left: 40px;
    height: 33px;
    width: 40px;
    float: left;
  }
  #page-break .jumpbox .jumpbtn {
    cursor: pointer;
    margin-left: 10px;
  }
  #page-break .jumpbox .jumpbtn:active {
    color: #337ab7;
  }

</style>



// WEBPACK FOOTER //
// src/components/homeworkManageTea.vue